import { Component } from 'react';
import ReactDOM from 'react-dom';
import { Transition } from 'react-transition-group';

import { AvailableLocale } from '../../shared/intl/types';
import { Overlay } from '../Modal/Overlay';

import { Menu } from './Menu';

type Props = {
    locale: AvailableLocale;
    opened: boolean;
    onClose: () => void;
    username: string;
};

export class MenuWithTransition extends Component<Props> {
    render(): JSX.Element | null | false {
        const { opened, username, onClose, locale } = this.props;
        return (
            typeof document !== 'undefined' &&
            document.getElementById('app-container') &&
            ReactDOM.createPortal(
                <div>
                    <Transition
                        in={opened}
                        timeout={{
                            enter: 0,
                            exit: 300,
                        }}
                        mountOnEnter
                        unmountOnExit
                    >
                        {(status) => (
                            <Overlay status={status}>
                                <Menu
                                    status={status}
                                    onClose={onClose}
                                    username={username}
                                    locale={locale}
                                    opened={opened}
                                />
                            </Overlay>
                        )}
                    </Transition>
                </div>,
                document.getElementById('app-container') as Element,
            )
        );
    }
}
